<template>
    <div class="bg-color-black">
        <div class="d-flex pt-2 pl-2" style="padding:0.3rem 0 0 0.3rem">
                <span style="color:#5cd9e8">
                  <icon name="chart-line"></icon>
                </span>
            <div class="d-flex">
                <span class="fs-xl text mx-2">设备区域</span>
                <dv-decoration-3 style="width:1.25rem;height:.25rem; position:relative;top:-.0375rem;" />
            </div>
        </div>
        <div style="width:3.25rem; height: 6rem;">
            <el-tree
                    class="filter-tree"
                    :data="addressTree"
                    :props="defaultProps"
                    default-expand-all
                    ref="tree"
                    @node-click="handleNodeClick"
            >
            </el-tree>
        </div>
    </div>
</template>

<script>
  import echartMixins from "@/utils/resizeMixins";

  export default {
    props:{
      addressTree: Array
    },
    data() {
      return {
        defaultProps: {
          children: 'children',
          label: 'label'
        },
      }
    },
    mixins: [echartMixins],
    methods: {
      handleNodeClick(node) {
        console.log(node.values)
        if (node.values !== undefined){
          var reg = new RegExp("[\\u4E00-\\u9FFF]+","g");
          if(!reg.test(node.values)) {
            console.log('ok')
            //设备号
            this.$emit('getParams', {'device_imei': node.values})
          }
        }
        else{
          console.log('省市区节点')
        }
      },
    }
  };
</script>

<style lang="scss" scoped>
    .bg-color-black {
        height: 6rem;
        border-radius: 0.125rem;
    }
    /*.filter-tree{*/
    /*    overflow-x: hidden;*/
    /*    overflow-y: scroll;*/
    /*    line-height: 30px;*/
    /*    text-align: center;*/
    /*    background-color: transparent;*/
    /*    height: 6.5rem;*/
    /*}*/
    .filter-tree{
        height: 5.25rem;
        padding:10px 20px;
        box-sizing: border-box;
        /*设置纵向滚动条、横向滚动条要配合下面的.el-tree-node的样式才能实现*/
        overflow: scroll;
        background-color: transparent;
        width: 6rem;
        /*top: 15px;*/
        color: #5cd9e8;
    }
    .el-tree>.el-tree-node{
        /*设置横向滚动条*/
        min-width: 100%;
        display: inline-block;
        .el-tree-node__content{
            display: none;
        }

    }
    .el-tree::-webkit-scrollbar {/*滚动条整体样式*/
        width: 10px;     /*高宽分别对应横竖滚动条的尺寸*/
        height: 1px;
    }

    .el-tree::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
        border-radius: 10px;
        -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        background: #07304b;
    }

    .el-tree::-webkit-scrollbar-track {/*滚动条里面轨道*/
        -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        border-radius: 10px;
        background: transparent;
    }
</style>
